<template>
  <div class="modal fade" id="ack-popup">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <a href="#" class="modal-close" data-dismiss="modal" aria-label="Close"><em class="ti ti-close"></em></a>
        <div class="ath-container m-0">
          <div class="ath-body bg-theme tc-light">
            <h5 class="ath-heading title">Sign in <small class="tc-default">with your QuBit Account</small></h5>
            <div class="text-center">
              <img src="/static/images/custom/lock.svg" alt="lock-img">
            </div><br>
            <div class="text-center">
              {{errAck}}
              <br><br>
              <!-- <button class="btn btn-primary btn-block btn-md"> Login / Signup </button> -->
              <a href="https://dance.qubit.ng/auth/login" target="_blank" class="btn btn-link btn-primary btn-block btn-md">Login / Signup</a>
            </div> <br><br>

            <div class="row">
              <div class="col-6 col-sm-6">
                <a href="https://play.google.com/store/apps/details?id=com.imaxinacion.nipost.qubit" target="_blank">
                  <img src="/static/images/custom/download-google.png" alt="google-download">
                </a>
              </div>
              <div class="col-6 col-sm-6">
                <a href="https://apps.apple.com/ng/app/nipost-qubit/id1477681785#?platform=iphone" target="_blank"> 
                  <img src="/static/images/custom/download-apple.png" alt="apple-download">
                </a>
              </div>
            </div>
            <div class="ath-note text-center" style="display:none;">
                Don’t have an account? <a href="#"> <strong>Sign up here</strong></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Loading from 'vue-loading-overlay'
// import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: {
    // Loading
  },
  computed: {
    // isLoading () {
    //   return this.$store.state.loading
    // },
    // serial () {
    //   return !this.$store.state.serialInfo ? false : this.$store.state.serialInfo.info.stamp
    // },
    // imgSrc () {
    //   return !this.$store.state.img ? false : this.$store.state.img
    // },
    errAck () {
      return this.$store.state.errorAck
    }
  }
}
</script>
